class AppointmentStatus {
    static DRAFT = "DRAFT";
    static SCHEDULING = "SCHEDULING";
    static FIXED = "FIXED";
    static FINISHED = "FINISHED";

    static toStatusString(status: AppointmentStatus): string {
        switch (status) {
            case AppointmentStatus.DRAFT:
                return "작성중";
            case AppointmentStatus.SCHEDULING:
                return "투표중";
            case AppointmentStatus.FIXED:
                return "약속확정";
            case AppointmentStatus.FINISHED:
                return "완료";
            default:
                return "N/A";
        }
    }
}

export default AppointmentStatus;